export enum LanguageCodes {
  English = "en",
  Persian = "fa",
  Arabic = "ar",
  Turkish = "tr",
  Spanish = "es",
  French = "fr",
  Portuguese = "pt",
  Darija = "da", // Darija (Moroccan Arabic)
  Vietnamese = "vi",
}
